import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData } from '@core/utils/dialog-utils';

@Component({
  selector: 'kmt-remarks-input-dialog',
  templateUrl: './remarks-input-dialog.component.html',
  styleUrls: ['./remarks-input-dialog.component.scss'],
})
export class RemarksInputDialogComponent implements OnInit {
  public text_area: string;
  constructor(
    public dialogRef: MatDialogRef<RemarksInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public confirm: ConfirmDialogData
  ) {
    console.log(confirm, 'confirm');
  }

  ngOnInit() {}

  onClose(isActive: boolean) {
    if (this.confirm.isRequired && isActive) {
      if (!this.text_area) {
        return null;
      }
    }
    this.close(isActive);
  }

  close(isActive: boolean) {
    this.dialogRef.close({ event: isActive, data: this.text_area });
  }
}
